import { createStore } from '@ngneat/elf';
import { withEntities } from '@ngneat/elf-entities';
import {
  Arrangement,
  ArrangementResource,
  Cluster,
  ClusterWithArrangements,
  Method,
  Resource,
} from '@thiememeulenhoff/types';
import { ContentEntry } from '@root/packages/types/src/content/content.types';

export const resources = createStore(
  { name: 'resources' },
  withEntities<Resource, 'contentIdentifier'>({
    idKey: 'contentIdentifier',
  }),
);

export const flattenedresources = createStore(
  { name: 'resources' },
  withEntities<Resource, 'contentIdentifier'>({
    idKey: 'contentIdentifier',
  }),
);

export const content = createStore(
  { name: 'content' },
  withEntities<ContentEntry, 'contentIdentifier'>({
    idKey: 'contentIdentifier',
  }),
);

export const methods = createStore(
  { name: 'methods' },
  withEntities<Method, 'slug'>({
    idKey: 'slug',
  }),
);

export const clustersWithArrangements = createStore(
  { name: 'clustersWithArrangements' },
  withEntities<ClusterWithArrangements, 'code'>({
    idKey: 'code',
  }),
);

export const arrangements = createStore(
  { name: 'arrangements' },
  withEntities<Arrangement, 'code'>({
    idKey: 'code',
  }),
);

/**
 * The arrangement resource tree saved by the arrangement code
 */
export const arrangementResourceByCode = createStore(
  { name: 'arrangementResource' },
  withEntities<ArrangementResource, 'code'>({
    idKey: 'code',
  }),
);

/**
 * Arrangement resources saved by the contentIdentifier
 */
export const arrangementResources = createStore(
  { name: 'arrangementResources' },
  withEntities<ArrangementResource, 'contentIdentifier'>({
    idKey: 'contentIdentifier',
  }),
);

export const referencesResources = createStore(
  { name: 'arrangementResources' },
  withEntities<Resource, 'contentIdentifier'>({
    idKey: 'contentIdentifier',
  }),
);

export const clusters = createStore(
  { name: 'clusters' },
  withEntities<Cluster, 'code'>({
    idKey: 'code',
  }),
);
